const css = `.M2GCMq__listItem{scroll-margin:40px}`;
document.head
    .appendChild(document.createElement("style"))
    .appendChild(document.createTextNode(css));
export {css};

export default {"listItem":"M2GCMq__listItem"};
